// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/activity/activity_preferences.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_common } from "../../core/common_pb";
import { file_proto_model_feature_activity_activity } from "./activity_pb";

/**
 * Describes the file proto/model/feature/activity/activity_preferences.proto.
 */
export const file_proto_model_feature_activity_activity_preferences = /*@__PURE__*/
  fileDesc("Cjdwcm90by9tb2RlbC9mZWF0dXJlL2FjdGl2aXR5L2FjdGl2aXR5X3ByZWZlcmVuY2VzLnByb3RvEgZjYXJtZW4iXQoRQWN0aXZpdHlGcmVxdWVuY3kSIgoIYWN0aXZpdHkYASABKAsyEC5jYXJtZW4uQWN0aXZpdHkSJAoJZnJlcXVlbmN5GAIgASgOMhEuY2FybWVuLkZyZXF1ZW5jeSK3AwoTQWN0aXZpdHlQcmVmZXJlbmNlcxI3ChRwcmVmZXJyZWRfYWN0aXZpdGllcxgBIAMoCzIZLmNhcm1lbi5BY3Rpdml0eUZyZXF1ZW5jeRIsChJhdm9pZGVkX2FjdGl2aXRpZXMYAiADKAsyEC5jYXJtZW4uQWN0aXZpdHkSOQoYYWN0aXZpdHlfYWR2ZW50dXJvdXNuZXNzGAMgASgOMhcuY2FybWVuLkFkdmVudHVyb3VzbmVzcxIaCgRwYWNlGAQgASgOMgwuY2FybWVuLlBhY2USMgoRdHJhdmVsZXJfcHJvZmlsZXMYBSADKA4yFy5jYXJtZW4uVHJhdmVsZXJQcm9maWxlEjUKGW1heF9oaWdobGlnaHRfcHJpY2VfbGV2ZWwYBiABKA4yEi5jYXJtZW4uUHJpY2VMZXZlbBIcChRmYW1pbHlfZnJpZW5kbHlfb25seRgHIAEoCBIyChNwcmVmZXJyZWRfZHVyYXRpb25zGAggAygOMhUuY2FybWVuLlZpc2l0RHVyYXRpb24SJQodcmVxdWlyZV93aGVlbGNoYWlyX2FjY2Vzc2libGUYCSABKAgqZgoEUGFjZRIUChBQQUNFX1VOU1BFQ0lGSUVEEAASEgoOUEFDRV9MRUlTVVJFTFkQARIRCg1QQUNFX01PREVSQVRFEAISDwoLUEFDRV9BQ1RJVkUQAxIQCgxQQUNFX0VYVFJFTUUQBEI5WjdnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9mZWF0dXJlL2FjdGl2aXR5YgZwcm90bzM", [file_proto_model_core_common, file_proto_model_feature_activity_activity]);

/**
 * Describes the message carmen.ActivityFrequency.
 * Use `create(ActivityFrequencySchema)` to create a new message.
 */
export const ActivityFrequencySchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_activity_activity_preferences, 0);

/**
 * Describes the message carmen.ActivityPreferences.
 * Use `create(ActivityPreferencesSchema)` to create a new message.
 */
export const ActivityPreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_activity_activity_preferences, 1);

/**
 * Describes the enum carmen.Pace.
 */
export const PaceSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_activity_activity_preferences, 0);

/**
 * @generated from enum carmen.Pace
 */
export const Pace = /*@__PURE__*/
  tsEnum(PaceSchema);

